import TextInput from './TextInput'

class BitmapTextInput extends TextInput {

    renderText(x, y, value, styles) {
        const text = this.game.add.bitmapText(x, y, styles.font, value, styles.fontSize);

        text.tint = this.ensureHexColor(styles.fill);

        return text ;
    }
}

export default BitmapTextInput;



// WEBPACK FOOTER //
// ./app/src/display/BitmapTextInput.js